import {Component, Directive, ViewEncapsulation} from '@angular/core';

@Directive({
  selector: 'cyb-header-nav',
  host: {'class': 'cyb-header-nav'}
})
export class CybHeaderNavDirective {}

@Directive({
  selector: 'cyb-header-content',
  host: {'class': 'cyb-header-content'}
})
export class CybHeaderContentDirective {}

@Directive({
  selector: 'cyb-header-logo',
  host: {'class': 'cyb-header-logo'}
})
export class CybHeaderLogoDirective {}

@Directive({
  selector: 'cyb-header-title',
  host: {'class': 'cyb-header-title'}
})
export class CybHeaderTitleDirective {}

@Component({
  selector: 'cyb-header',
  template: `<div class="cyb-header-container">
  <ng-content></ng-content>
</div>
`,
  styles: [`.cyb-header{background-color:#003245;height:90px;margin-bottom:15px;box-shadow:0 1px 2px rgba(0,0,0,.5);position:relative;background-image:url(/assets/img/bg-header.jpg);background-size:100% 100%;box-sizing:border-box;display:block}.cyb-header-nav{height:33px;position:relative;display:block}.cyb-header-container{width:95%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;box-sizing:border-box;display:block;max-width:1600px;min-width:750px}.cyb-header-title{font-size:1.4rem;color:#fff;float:right;margin:5px 0 0;font-family:TelefonicaCap;width:66.66666667%;text-align:right}.cyb-header-logo{width:33.33333333%;float:left;position:relative;min-height:1px;padding-right:15px;padding-left:15px;box-sizing:border-box}.cyb-header-logo img{width:156px;height:40px;vertical-align:middle}`],
  encapsulation: ViewEncapsulation.None,
  host: {'class': 'cyb-header'}
})

export class CybHeaderComponent {}
